import React from 'react'
import PropTypes from 'prop-types'
import {
  Container,
  Columns,
  Column,
  RadioButtonGroup,
} from '@resurs/midas-react'
import { getText } from '../../../../internal/TextLabels/text'

const PendingApplications = ({
  availableAccounts,
  onApplicationSelected,
  selectedValue,
}) => {
  return (
    <Container>
      <Columns>
        <Column col12>
          <div style={{ fontSize: '2.5rem' }}>
            {getText('payApply.paymentMethods.pendingApplications.title')}
          </div>
          <div style={{ color: 'grey', paddingTop: '0.2rem' }}>
            {getText(
              'payApply.paymentMethod.descriptions.private.PENDING_APPLICATIONS',
            )}
          </div>
        </Column>
        <Column col12>
          <RadioButtonGroup
            name="pending-applications-options"
            id="available-applications"
            values={availableAccounts}
            defaultCheckedValue={selectedValue}
            onChange={e => onApplicationSelected(e.target.value)}
            styling={{
              border: '1px solid lightgrey',
              marginBottom: '1rem',
              padding: '0.7rem',
              width: '100%',
            }}
          />
        </Column>
      </Columns>
    </Container>
  )
}

PendingApplications.propTypes = {
  availableAccounts: PropTypes.array.isRequired,
  onApplicationSelected: PropTypes.func.isRequired,
  selectedValue: PropTypes.string.isRequired,
}

export default PendingApplications
